export const ACTIVITIES_CREATE_START = '@activities/create_start';

export const createActivity = (payload) => ({
  type: ACTIVITIES_CREATE_START,
  payload,
});
